// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-492d8a51],.cls-2[data-v-492d8a51]{fill:#fff}.cls-1[data-v-492d8a51]{opacity:0}.cls-2[data-v-492d8a51]{fill-rule:evenodd}", ""]);
// Exports
module.exports = exports;
